import React from 'react';

import { Typography, Button } from '@mui/material';

import { ReactComponent as FilterIcon } from '../../../../common/assets/icons/filter_icon.svg';
import { ReactComponent as FilterIconOrange } from '../../../../common/assets/icons/filter_icon_orange.svg';

type Props = {
  isLoading: boolean;
  filtersLength: number;
  selectedFilterIcon: () => void;
};

const FilterCodesButton: React.FC<Props> = ({
  isLoading,
  filtersLength,
  selectedFilterIcon,
}) => {
  return (
    <>
      {filtersLength === 0 ? (
        <Button
          disabled={isLoading}
          onClick={() => selectedFilterIcon()}
          sx={{
            borderRadius: '100px',
          }}
          color='darkBlue'
          variant='contained'
          disableElevation
        >
          <FilterIcon style={{ marginLeft: 10, flexShrink: 0 }} />
        </Button>
      ) : (
        <Button
          disabled={isLoading}
          onClick={() => selectedFilterIcon()}
          sx={{
            borderRadius: '100px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            border: 'solid',
            borderWidth: '1.5px',
            borderColor: 'appOrange.main',
            flexShrink: 0,
            marginTop: '6px',
            marginBottom: '6px',
          }}
          color='paleOrange'
          variant='contained'
          disableElevation
        >
          <Typography color='appOrange.main'>{filtersLength}</Typography>
          <FilterIconOrange style={{ marginLeft: 10, flexShrink: 0 }} />
        </Button>
      )}
    </>
  );
};

export default FilterCodesButton;
